import * as t from "io-ts"

export const EmbeddedUrlResponse = t.type({
    body: t.string,
})

export type IEmbeddedUrlResponse = t.TypeOf<typeof EmbeddedUrlResponse>
